import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface RegistrationState {
  phoneNumber: string
  registrationStep: string
  identificationRequestId: string | null
}

const initialState: RegistrationState = {
  phoneNumber: "",
  registrationStep: "initial",
  identificationRequestId: null,
}

const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    setRegistrationPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload
    },
    setRegistrationStep: (state, action: PayloadAction<string>) => {
      state.registrationStep = action.payload
    },
    setIdentificationRequestId: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.identificationRequestId = action.payload
    },
    resetRegistration: () => initialState,
  },
})

export const {
  setRegistrationPhoneNumber,
  setRegistrationStep,
  setIdentificationRequestId,
  resetRegistration,
} = registrationSlice.actions

export default registrationSlice.reducer
